const config = {
  Auth: {
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_fpooO0wgE',
    userPoolWebClientId: '5ijhhv5clc438btps3tvrlm15a',
  },
};

export default config;
